module.exports = __webpack_public_path__ + "img/white_arrow.be3ca5cb.svg";